import { render, staticRenderFns } from "./InclusiveNode.vue?vue&type=template&id=1cd157b0&scoped=true"
import script from "./InclusiveNode.vue?vue&type=script&lang=js"
export * from "./InclusiveNode.vue?vue&type=script&lang=js"
import style0 from "./InclusiveNode.vue?vue&type=style&index=0&id=1cd157b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd157b0",
  null
  
)

export default component.exports